/**
 * @return {boolean}
 */
export const isDevelopment = () => process.env.NODE_ENV === 'development'



// WEBPACK FOOTER //
// ./src/utils/env/isDevelopment.js